import {createSlice} from "@reduxjs/toolkit";

const initialLinksState = {
  listLoading: false,
  actionsLoading: false,
  lastError: null,
  totalCount: 0,
  qnaList: null,
  qna: undefined,
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const QNASlice = createSlice({
  name: "qna",
  initialState: initialLinksState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findQNAList
    QNAListFetched: (state, action) => {
      const { totalCnt, csList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.qnaList = csList;
      state.totalCount = totalCnt;
    },
    // getQNAById
    QNAFetched: (state, action) => {
      const {qna} = action.payload;
      state.actionsLoading = false;
      state.qna = qna;
      state.error = null;
    },
  }
});
